import { Grid } from '@mui/material';
import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RoutalColorPicker, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import InputText from '../../../react-components/InputText';
import Text from '../../../react-components/Text';

interface StylingColorPickerProps {
  label?: string;
  disabled?: boolean;
  color: HexColor;
  containerStyle?: React.CSSProperties;
  inputContainerStyles?: React.CSSProperties;
  onChange: (color: HexColor) => void;
}

export const StylingColorPicker = ({
  label,
  disabled = false,
  color,
  containerStyle = {},
  inputContainerStyles = {},
  onChange,
}: StylingColorPickerProps) => {
  return (
    <Grid container direction="column" style={{ ...containerStyle }}>
      {label ? (
        <>
          <Text
            style={{
              color: disabled ? RoutalPalette.grey7 : RoutalPalette.secondary40,
            }}
          >
            {label}
          </Text>
          <VSpacer small />
        </>
      ) : null}

      <InputText
        disabled={disabled}
        fieldValue={color.value}
        onChange={(value: string) => {
          if (HexColor.isValidHexColor(value ?? ``)) {
            onChange(HexColor.create(value));
          }
        }}
        inputContainerStyles={{
          paddingRight: `8px`,
          width: `140px`,
          ...inputContainerStyles,
        }}
        inputProps={{
          maxLength: 7,
        }}
        validators={[
          {
            errorMessage: (
              <Text
                tagName="span"
                style={{ cursor: `default`, color: RoutalPalette.error.medium }}
                intlId="invalid_color"
              />
            ),
            isInvalid: (text?: string) => {
              return !HexColor.isValidHexColor(text ?? ``);
            },
          },
        ]}
        endAdornment={
          <RoutalColorPicker
            disabled={disabled}
            color={color.value}
            onUpdate={(hex: string) => {
              onChange(HexColor.create(hex));
            }}
          />
        }
      />
    </Grid>
  );
};
